module.exports = __webpack_public_path__ + "3092a1238f4b5a8513077d8ed2c5e354.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/loops/loop1.wav
// module id = 86
// module chunks = 0